import React, {useEffect} from 'react';
import {Divider, Typography} from '@mui/material';

import Container from '../../components/Container';
import Main from '../../layouts/Main';
import DataStats from './components/DataStats';
import DataVisualization from './components/DataVisualization';
import DataLibrary from './components/DataLibrary';

const Data = (): JSX.Element => {
  
useEffect(() => {
    const hash = window.location.hash.slice(1); // Remove the '#' character from the hash
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <Main>
      <Container>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={0.5}
            paddingBottom={2}
            >
            OCPF Data Center
        </Typography>
        <Divider/>
        <DataStats></DataStats>
        <section id="monthly-charts">
          <Divider/>
        </section>
        <DataVisualization></DataVisualization>
        <Divider/>
        <DataLibrary></DataLibrary>
      </Container>
    </Main>
  );
};

export default Data;